export const apiConstants = {
  url: "/api/supplier"
};
